'use strict';

angular.module('portal.services', ['ngAnimate', 'ui.bootstrap'])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            // portal routings
            // services tab
            .state('portal.menus.service', {
                abstract: true,
                templateUrl: paths.app + 'services/components/service/service.html',
                controller: 'PortalService',
                params: {
                    id: null,
                    service: null
                }
            })
            .state('portal.menus.servicesNew', {
                url: '/service/list',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'PortalClinicians',
                params: {
                    id: null,
                    service: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.service.inspections', {
                url: '/service/:id/inspectionsList',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'PortalClinicians',
                params: {
                    id: null,
                    service: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.service.inspectionsOld', {
                url: '/service/:id/inspections',
                templateUrl: paths.app + 'services/components/inspections/inspections.html',
                controller: 'PortalServiceInspections',
                params: {
                    id: null,
                    service: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.service.clinicians', {
                url: '/service/:id/clinicians',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'PortalClinicians',
                params: {
                    id: null,
                    service: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.service.dashboard', {
                url: '/service/:id/dashboard',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'PortalClinicians',
                params: {
                    id: null,
                    service: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access || $rootScope.userAccount.service_permission !== true) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.service.demographicsNew', {
                url: '/service/:id/demographics',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'PortalClinicians',
                params: {
                    id: null,
                    service: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access || $rootScope.userAccount.service_permission !== true) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.service.medicaldirectors', {
                url: '/service/:id/medicalDirectors',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'PortalClinicians',
                params: {
                    id: null,
                    service: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access || $rootScope.userAccount.service_permission !== true) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.service.vehiclelist', {
                url: '/service/:id/vehicles',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'PortalClinicians',
                params: {
                    id: null,
                    service: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access || $rootScope.userAccount.service_permission !== true) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.service.vehicleDetails', {
                url: '/service/:id/vehicle/:vehicleId/details',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'PortalClinicians',
                params: {
                    id: null,
                    vehicleId: null,
                    service: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        // The access permission of 'portal.menus.service.vehicleDetails' page depends on 'portal.menus.service.vehiclelist' page:
                        return PortalPermissions.view('portal.menus.service.vehiclelist').then(function (access) {
                            if (!access || $rootScope.userAccount.service_permission !== true) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.service.organization', {
                url: '/service/:id/organization',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'PortalClinicians',
                params: {
                    id: null,
                    service: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access || $rootScope.userAccount.service_permission !== true) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.service.personnel', {
                url: '/service/:id/personnel',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'PortalClinicians',
                params: {
                    id: null,
                    service: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access || $rootScope.userAccount.service_permission !== true) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.service.locationlist', {
                url: '/service/:id/locations',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'PortalClinicians',
                params: {
                    id: null,
                    service: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access || $rootScope.userAccount.service_permission !== true) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.service.locationDetails', {
                url: '/service/:id/locations/:locationId',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'PortalClinicians',
                params: {
                    id: null,
                    service: null,
                    locationId: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view("portal.menus.service.locationlist").then(function (access) {
                            if (!access || $rootScope.userAccount.service_permission !== true) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.service.staffDetails', {
                url: '/service/:id/staff',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'PortalClinicians',
                params: {
                    id: null,
                    service: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access || $rootScope.userAccount.service_permission !== true) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.service.documentlist', {
                url: '/service/:id/documents',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'PortalClinicians',
                params: {
                    id: null,
                    service: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access || $rootScope.userAccount.service_permission !== true) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.service.policyList', {
                url: '/service/:id/policies',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'PortalClinicians',
                params: {
                    id: null,
                    service: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access || $rootScope.userAccount.service_permission !== true) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.service.policyCreate', {
                url: '/service/:id/policies/:policyId',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'PortalClinicians',
                params: {
                    id: null,
                    service: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view("portal.menus.service.policyList").then(function (access) {
                            if (!access || $rootScope.userAccount.service_permission !== true) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.service.serviceAreasDetails', {
                url: '/service/:id/areas',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'PortalClinicians',
                params: {
                    id: null,
                    service: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access || $rootScope.userAccount.service_permission !== true) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.service.personnelPayment', {
                url: '/service/:serviceId/personnelPayment',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'PortalClinicians',
                params: {
                    serviceId: null,
                    service: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        // No Portal Page due to this is bulkActions toggling on/off by the view
                        if ($rootScope.userAccount.service_permission !== true) {
                            $state.go('portal.menus.denied');
                        }
                    }]
                }
            })
            .state('portal.menus.service.vouchers', {
                url: '/service/:id/vouchers',
                templateUrl: paths.app + 'services/components/vouchers/vouchers.html',
                controller: 'PortalVouchers',
                params: {
                    id: null,
                    service: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
    }])
    ;